export default __webpack_public_path__ + "static/rcf_logo-36b2e112202d03267e9f9eacc9f38a00.png";